import { render, staticRenderFns } from "./SquareButton.vue?vue&type=template&id=ca87b66a&scoped=true"
import script from "./SquareButton.vue?vue&type=script&lang=js"
export * from "./SquareButton.vue?vue&type=script&lang=js"
import style0 from "./SquareButton.css?vue&type=style&index=0&id=ca87b66a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca87b66a",
  null
  
)

export default component.exports